import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { Lod } from '@sloyd/ui';
import { bridge } from '@sloyd/viewer';
import { useMemo } from 'react';

const DEFAULT_LOD = 0.5;

export type LodProps = {
  instanceId: string;
};

export function LodContainer(props: LodProps) {
  const { instanceId = 'main' } = props;
  const dispatch = useDispatch();
  const holodeckState = useSelector(selectors.raw.$rawHolodeckState);
  const backdrops = useSelector(selectors.gallery.$backdrops);
  const currentModel = useSelector(selectors.single.$currentModel);
  const { valuesModel } = currentModel ?? {};
  const { LOD = DEFAULT_LOD } = valuesModel ?? {};

  const callbacks = useMemo(
    () => ({
      onChange: (_: any, value: string | number) => {
        bridge.patchValuesModel(instanceId, { LOD: value });
      },
      onSet: (_: any, value: string | number) => {
        bridge.patchValuesModel(instanceId, { LOD: value });
        dispatch(actions.valuesModel.patch({ LOD: value }));
      },
      onReset: () => {
        bridge.patchValuesModel(instanceId, { LOD: DEFAULT_LOD });
        dispatch(actions.valuesModel.patch({ LOD: DEFAULT_LOD }));
      },
    }),
    []
  );

  return <Lod lod={LOD} onChange={callbacks.onChange} onSet={callbacks.onSet} />;
}

export default LodContainer;
